import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "ajoutDosageApp", fr_CA);
i18next.addResourceBundle("en-CA", "ajoutDosageApp", en_CA);

export const ajoutDosageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "ajoutDosage",
  auth: "item_management",
  routes: [
    {
      path: "/app/ajoutDosage/item/:itemId",
      component: React.lazy(() => import("./views/Item")),
    },
    {
      path: "/app/ajoutDosage/list",
      component: React.lazy(() => import("./views/List")),
    },
    {
      path: "/app/ajoutDosage",
      component: () => <Redirect to="/app/ajoutDosage/list" />,
    },
  ],
};
